import React from 'react'

import { ButtonWrapper } from './ButtonWrapper'
import { Icon } from '../../../module'
import { type ButtonProps, type IconProps } from '../Button.models'
import styles from '../_button.module.scss'
import { c } from '../../../translations/LibraryTranslationService'

type IconButtonProps = IconProps & {
  buttonProps: Omit<ButtonProps, 'icon' | 'destructive'>
}

const IconButton = (props: IconButtonProps): React.JSX.Element => {
  const { buttonProps, icon, destructive } = props
  if (
    buttonProps.styleType &&
    ['text-blue', 'text-red'].includes(buttonProps.styleType) &&
    icon
  ) {
    throw new Error(
      c('errorIconButtonStyleType', {
        styleType: buttonProps.styleType,
      }),
    )
  }

  const allClassNames = `${buttonProps.className} ${styles.iconButton} ${buttonProps.styleType?.includes('primary') ? styles.primary : ''}`

  return (
    // @ts-expect-error Types are getting lost when spreading buttonProps here. Ignoring the type error.
    <ButtonWrapper {...buttonProps} className={allClassNames} icon={icon}>
      <Icon
        icon={icon}
        className={destructive ? styles.destructive : ''}
        iconSize='16px'
        {...(destructive ? { color: 'dark-red' } : { color: 'dark-purple' })}
      />
    </ButtonWrapper>
  )
}

export default IconButton
